const contactFragment = `
  id
  firstName
  lastName
  email
  phoneNumber
  createdAt
  updatedAt
`;

const contactListFragment = `
  id
  name
  contactCount
  contacts {
    ${contactFragment}
  }
`;

export const sendGridListContactListsQuery = `
  query SendGridListContactLists($companyId: Int!) {
    items: sendGridListContactLists(companyId: $companyId) {
      ${contactListFragment}
    }
  }
`;

export const sendGridGetContactListQuery = `
  query SendGridGetContactList($id: String!, $companyId: Int!) {
    item: sendGridGetContactList(id: $id, companyId: $companyId) {
      ${contactListFragment}
    }
  }
`;

export const sendGridCreateContactListQuery = `
  mutation SendGridCreateContactList($input: SendGridCreateContactListInput!) {
    item: sendGridCreateContactList(input: $input) {
      ${contactListFragment}
    }
  }
`;

export const sendGridUpdateContactListQuery = `
  mutation SendGridUpdateContactList($input: SendGridUpdateContactListInput!) {
    item: sendGridUpdateContactList(input: $input) {
      ${contactListFragment}
    }
  }
`;

export const sendGridDeleteContactListQuery = `
  mutation SendGridDeleteContactList($id: String!, $companyId: Int!) {
    item: sendGridDeleteContactList(id: $id, companyId: $companyId) {
      id
    }
  }
`;

export const sendGridSaveContactQuery = `
  mutation SendGridSaveContact($input: SendGridSaveContactInput!) {
    item: sendGridSaveContact(input: $input) {
      ${contactFragment}
    }
  }
`;

export const sendGridDeleteContactFromListQuery = `
  mutation SendGridDeleteContactFromList($id: String!, $listId: String!, $companyId: Int!) {
    item: sendGridDeleteContactFromList(id: $id, listId: $listId, companyId: $companyId) {
      id
    }
  }
`;

export const createSendGridWebhookMutation = `
  mutation CreateSendGridWebhook(
    $companyId: Int!
  ) {
    created: createSendGridWebhook(companyId: $companyId)
  }
`;

export const disableSendGridWebhookMutation = `
  mutation DisableSendGridWebhook(
    $companyId: Int!
  ) {
    disabled: disableSendGridWebhook(companyId: $companyId)
  }
`;
